export default {
  VITE_BACKEND_URL: import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:5001',

  RECRUITER_APP_BASE_URL: import.meta.env.VITE_RECRUITER_APP_BASE_URL,
  MYHUBERT_BASE_URL: import.meta.env.VITE_MYHUBERT_BASE_URL,
  MYHUBERT_BACKEND_URL: import.meta.env.VITE_MYHUBERT_BACKEND_URL,
  CHAT_INTERVIEW_BASE_URL: import.meta.env.VITE_CHAT_INTERVIEW_BASE_URL,

  SCORING_BASE_URL: import.meta.env.VITE_SCORING_BASE_URL,

  QUTTER_ACK_URL: import.meta.env.VITE_QUTTER_ACK_URL,
  QUTTER_ACK_USERNAME: import.meta.env.VITE_QUTTER_ACK_USERNAME,
  QUTTER_ACK_PASSWORD: import.meta.env.VITE_QUTTER_ACK_PASSWORD,
  QUTTER_ACK_TIMEOUT: import.meta.env.VITE_QUTTER_ACK_TIMEOUT,
  // Reusage live === 1, killed === 0
  REUSAGE_AVAILABILITY: parseInt(import.meta.env.VITE_REUSAGE_AVAILABILITY) === 1,

  VITE_VERSION: import.meta.env.VITE_VERSION,
  VITE_ROLLBAR_TOKEN: import.meta.env.VITE_ROLLBAR_TOKEN,

  VITE_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,

  MODE: import.meta.env.MODE,
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,

  POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY,
  POSTHOG_API: import.meta.env.VITE_POSTHOG_API,
  POSTHOG_UI: import.meta.env.VITE_POSTHOG_UI,
};
